$('.faq__header-item').on('click', (e) => {
	let $this = $(e.currentTarget);

	let $body = $this.closest('.faq__item').find('.faq__body-item');

	if ($body.is(':hidden')) {
		$this.addClass('is-active');
		$body.slideDown(350);
	} else {
		$this.removeClass('is-active');
		$body.slideUp(350);
	}
});
